<!--列表查看视图-->
<template>
  <el-dialog
    v-el-drag-dialog
    custom-class="ai-trust-from-window"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.AssociationBusinessInformation')"
    :close-on-click-modal="true"
    @close="innerVisible=false"
  >
    <div class="main-content">
      <div :class="'tabs-container' + (canOperateJob ? '' : ' cannot-operate-job')">
        <span class="lab-state">{{ labState }}</span>
        <el-tabs ref="tabs" v-model="activeTabName" type="card" @tab-click="handleTabClick">
          <el-tab-pane v-if="currentRow && !currentRow.masterFlag" :key="101" name="basicTab" :label="$t('SeaExport.Basic')">
            <basic-tab ref="basicTab" :context="context" :action="action" />
          </el-tab-pane>
          <el-tab-pane v-if="currentRow && currentRow.masterFlag" :key="102" name="masterBasicTab" :label="$t('SeaExport.Basic')">
            <master-basic-tab ref="masterBasicTab" :context="context" :action="action" />
          </el-tab-pane>
          <el-tab-pane :key="103" v-permission="['button_AEBooking_portalState']" name="tabSopState" :label="$t('SeaExport.BusinessStatus')">
            <tab-sop-state ref="tabSopState" :context="context" :action="action" :show-button="showButton" />
          </el-tab-pane>
          <el-tab-pane :key="104" name="tabFileHistory" :label="$t('SeaExport.FileHistory')">
            <tab-file-history ref="tabFileHistory" :context="context" :action="action" :show-button="showButton" :can-operate-job="canOperateJob" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import basicTab from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabGeneral'
import masterBasicTab from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabMaster'
import tabSopState from '@/components/Cargo/Job/booking/tabs/tabSopState'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import { BookingWorkspaceContext } from '@/views/cargo/v0/AirExport/components/AeBooking/bookingWorkspaceContext'

export default {
  name: 'AiTrustFromWindow',
  components: {
    basicTab,
    masterBasicTab,
    tabSopState,
    tabFileHistory
  },
  props: {
    visible: { type: Boolean, required: true },
    trustJob: { type: Object, required: false, default: null },
    canOperateJob: { type: Boolean, default: true }
  },
  data() {
    return {
      context: new BookingWorkspaceContext(),
      showButton: false,
      innerVisible: false,
      action: 'look',
      currentRow: {},
      activeTabName: 'basicTab',
      labState: ''
    }
  },
  watch: {
    async visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    if (this.visible) {
      const loading = getLoading4Cxt()
      this.innerVisible = true
      this.$logger.log('trustJob', this.trustJob)
      await this.context.prepareData()
      await this.showDetail(this.trustJob)
      loading.close()
    }
  },
  methods: {
    async showDetail(trustJob) {
      this.currentRow = trustJob
      this.currentRow.path = ''
      this.labState = this.$t('SeaExport.BusinessStatus') + '：' + ColumnUtils.getJobStateCN(this.currentRow.jobState)
      this.activeTabName = this.currentRow.masterFlag ? 'masterBasicTab' : 'basicTab'
      this.handleTabClick()
    },
    handleTabClick() {
      this.$nextTick(() => {
        this.$refs[this.activeTabName].onShow(this.currentRow, true)
      })
    }
  }
}
</script>

<style lang="scss">
.el-dialog.ai-trust-from-window {
  display: flex;
  height: 600px;
  width: 1680px;
  flex-direction: column;
  .el-dialog {
    &__body {
      position: relative;
      display: flex;
      overflow: hidden;
    }
  }
  &.isfullScreen {
    overflow: hidden;
  }
  .el-tabs {
    display: flex;
    flex-direction: column;
    width: 100%;
    &__content {
      overflow: scroll;
    }
  }
  .lab-state {
    position: absolute;
    z-index: 999;
    right: 30%;
  }
  .tabs-container.cannot-operate-job {
    .el-button {
      &.el-button--primary:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #8fbaea;
        border-color: #8fbaea;
      }
      &.el-button--success:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #a1dcc1;
        border-color: #a1dcc1;
      }
      &.el-button--danger:not(.can-operate) {
        pointer-events: none;
        color: #FFFFFF;
        background-color: #fab6b6;
        border-color: #fab6b6;
      }
    }
    .sop-img {
      pointer-events: none;
    }
  }
}
</style>
